// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".planning-editor-header[data-v-4d0c3544] {\n  font-weight: 500;\n}\n.planning-preview[data-v-4d0c3544] {\n  border: 2px solid grey;\n  border-radius: 10px;\n  padding: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
